import relateModules from './relateModules'
import store from './store'
import update from './update'

const namespaced = true

export default {
  namespaced,
  modules: {
    relateModules,
    store,
    update
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/media/forms/index.js